/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate, useParams, Link } from 'react-router-dom'

import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import CardMedia from '@mui/material/CardMedia'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Collapse from '@mui/material/Collapse'
import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import EditIcon from '@mui/icons-material/Edit'
// import { Link } from '@mui/material'
import StarIcon from '@mui/icons-material/Star'
import SendIcon from '@mui/icons-material/Send'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

import { ExpandMore } from '../../../../helpers/cardHelpers'
import { getPayload, getTokenFromLocalStorage, userIsAuthenticated } from '../../../../helpers/storage'
import { positionChangeHeightSm, positionChangeWidthSm, swipelyticsPink, swipelyticsTurquoise } from '../../../../helpers/variableDefaults'
import useWindowDimensions from '../../../../helpers/windowDimensions'
import { standardButton } from '../../../../helpers/buttons'
import { dummyBox, capitalizeFirstLetter } from '../../../../helpers/globalHelpers'
import { profileCardImage } from '../../../../helpers/commonJSX'

import profPicDefault from '../../../../assets/seed-profpic-default-2.jpg'

const ReviewerSelectedItem = (props) => {
  
  // Window Dimensions
  const { height, width } = useWindowDimensions()

  // Destructure Props
  const { profile, user } = props
  // console.log('reviewer profile ->', profile)

  // Payload
  const payload = getPayload()

  // Navigate
  const navigate = useNavigate()

  // Params
  // const { userId } = useParams()

  // URL Path
  const urlPath = window.location.pathname

  // Tracks whether the card is expanded
  const [expanded, setExpanded] = useState(false)

  // Changes the card expanded state
  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  // useEffect(() => {
  
  // }, [])


  return (
    <Card 
      align="left" 
      sx={{ 
        mt: 2,
        backgroundColor: 'white',
        // width: width < positionChangeWidthSm ? '80%' : '95%', 
        width: '95%',
        // maxWidth: '400px',
        // boxShadow: 3, 
        borderRadius: 3,
        border: 2,
        borderColor: 'black',
        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start',
      }}
    >
      {/* Displays as a column on mobile and row on desktop */}
      <Box
        sx={{
          width: '100%',
          // display: 'flex', flexDirection: width < positionChangeWidthSm ? 'column' : 'row', justifyContent: width < positionChangeWidthSm ? 'flex-start' : 'space-between', alignItems: 'center',
          display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
        }}
      >
        <Box
          sx={{
            // height: width < positionChangeWidthSm ? '300px' : '200px',
            width: '100%',
            display: 'flex', flexDirection: width < positionChangeWidthSm ? 'column' : 'row', justifyContent: width < positionChangeWidthSm ? 'center' : 'flex-start', alignItems: width < positionChangeWidthSm ? 'center' : 'center',
          }}
        >

          {/* {console.log('media url ->', profile.media)} */}
          {/* Image */}
          {profileCardImage(profile, null, profPicDefault, width, 'reviewerSelected')}

          {/* Reviewer Summary */}
          <Box
            sx={{
              // backgroundColor: 'yellow',
              ml: width < positionChangeWidthSm ? 0 : 1,
              mb: width < positionChangeWidthSm ? 2 : 0,
              width: '100%',
              display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center',
            }}
          >
            {/* Name, Age, Gender, Sexuality */}
            <Typography
              textAlign={width < positionChangeWidthSm ? 'center' : 'left'}
              sx={{
                // backgroundColor: 'yellow',
                // mt: width < positionChangeWidthSm ? 0 : 1,
                mb: width < positionChangeWidthSm ? 0 : 1,
                width: '95%',
                fontSize: width < positionChangeWidthSm ? '16px' : '18px',
                fontWeight: 'bold',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: '1',
                WebkitBoxOrient: 'vertical',
              }}
            >
              {`${capitalizeFirstLetter(profile.bio.vitalInfo.firstName)}, ${profile.bio.vitalInfo.age}, ${profile.bio.vitalInfo.gender}, ${profile.bio.vitalInfo.sexuality}`}
            </Typography>

            {/* About Me */}
            <Box
              sx={{
                mt: 0,
                // mt: 2, py: 2, px: 2,
                width: '100%',
                height: '90px',
                backgroundColor: 'white',
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
              }}
            >
              <Typography
                textAlign={width < positionChangeWidthSm ? 'center' : 'left'}
                sx={{
                  // backgroundColor: 'yellow',
                  // mt: width < positionChangeWidthSm ? 0 : 1,
                  mb: width < positionChangeWidthSm ? 0 : 1,
                  width: '95%',
                  fontSize: width < positionChangeWidthSm ? '16px' : '18px',
                  // fontWeight: 'bold',
                  fontStyle: 'italic',
                  display: '-webkit-box',
                  overflow: 'hidden',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 3,
                  backgroundColor: 'white',
                }}
              >
                {'bio' in profile
                  && 'aboutMe' in profile.bio
                  && profile.bio.aboutMe.length > 0
                  ?
                  profile.bio.aboutMe[0]
                  :
                  profile.isAIReviewer ? 'AI Reviewer' : 'Expert Reviewer'
                }
                {/* Type: <span style={{ fontWeight: 'bold' }}>{profile.isAIReviewer ? 'AI Reviewer' : 'Expert Reviewer'}</span> */}
              </Typography>
            </Box>

          </Box>

        </Box>
      </Box>
      
    </Card>
  )
}

export default ReviewerSelectedItem